import { styled } from '@mui/material'
import { Color } from '../../../../../styles/commonStyles'

export const ActiveDot = styled('span')({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: Color.ALERT,
  marginLeft: '4px',
})
